import { useCallback, useMemo } from 'react';

import { SEARCH_INDEX_NAME_BASE, SEARCH_PRESET_BASE } from '#src/app/pages/search/shared/consts';
import { useLocale } from '#src/app/shared/hooks/l10n';
import { useTypesenseConfig } from '#src/app/shared/hooks/typesense';

type Result = ModelHookResult<{
	searchIndexName: string;
	searchPreset: string;
}>;

export function useSearchIndexName(): Result {
	const locale = useLocale();
	const [language] = locale.split('-');

	const { namespace } = useTypesenseConfig();

	const addNamespace = useCallback(
		(indexName: string): string => {
			return namespace ? `${namespace}_${indexName}` : indexName;
		},
		[namespace],
	);

	return {
		data: {
			searchIndexName: useMemo(() => {
				return addNamespace(`${SEARCH_INDEX_NAME_BASE}${language}`);
			}, [addNamespace, language]),
			searchPreset: useMemo(() => {
				return addNamespace(`${SEARCH_PRESET_BASE}${language}`);
			}, [addNamespace, language]),
		},
	};
}
